import { DatePattern } from '@utils/constants';
import moment from 'moment';

export const formatDate = (date = moment(), format = DatePattern.DATE) => {
  if (!date.isValid()) return '';
  return moment(date).format(format);
};

export const dayExpires = 7 * 24 * 60 * 60 * 1000;
export const dayExpires1Minute = 60 * 1000;
